export interface Article {
  id: string;
  title: string;
  excerpt: string;
  category: string;
  categorySlug: string;
  coverImage: string;
  publishDate: string;
  views: number;
  likes: number;
  duration: string;
  tags: string[];
  content: string;
  author: string;
  isHot: boolean;
  isNew: boolean;
  isFeatured: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '《流浪地球3》终极预告震撼发布，人类命运何去何从',
    excerpt: '备受期待的科幻巨制《流浪地球3》终于发布终极预告片，影片延续前两部的宏大叙事，展现了人类在宇宙漂流中面临的终极抉择。导演表示这将是系列最具震撼力的一部。',
    category: '电影',
    categorySlug: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20cinematic%20movie%20poster%20style%20image%20showing%20a%20futuristic%20sci-fi%20scene%20with%20astronauts%20in%20space%2C%20dramatic%20lighting%2C%20epic%20scale%2C%20warm%20orange%20and%20deep%20space%20tones%2C%20cinematic%20composition%20with%20lens%20flare%2C%20professional%20movie%20photography%20style&width=800&height=450&seq=article-cover-1&orientation=landscape',
    publishDate: '2026-08-07',
    views: 128900,
    likes: 45200,
    duration: '02:35',
    tags: ['科幻', '国产电影', '流浪地球', '预告片'],
    content: '<p>备受期待的科幻巨制《流浪地球3》终于发布了终极预告片，这部由郭帆执导的系列第三部作品，延续了前两部建立的世界观，将故事推向了一个全新的高度。</p><p>在预告片中，我们看到人类的行星发动机面临着前所未有的危机，地外文明的信号被接收后，整个流浪地球计划陷入了巨大的不确定性。刘德华、吴京等原班人马悉数回归，同时加入了多位实力派新演员。</p><p>影片的特效制作再次升级，大量令人窒息的太空场景和宏大场面的呈现，让每一位观众都能感受到视觉上的震撼。导演郭帆在接受采访时表示："这一部将是对整个系列最好的总结，也是对人类的终极考验。"</p><p>据悉，《流浪地球3》将于2026年国庆档上映，目前预售票房已突破3亿，创下了国产科幻电影的预售新纪录。</p>',
    author: '影视观察员',
    isHot: true,
    isNew: false,
    isFeatured: true,
  },
  {
    id: 'article-2',
    title: '《繁花似锦》大结局收视率破纪录，主演阵容引爆话题',
    excerpt: '都市情感剧《繁花似锦》昨夜迎来大结局，全国收视率突破3.8%，创下今年电视剧收视新高。主演们的精彩表演让观众大呼过瘾，社交媒体话题量超20亿。',
    category: '电视剧',
    categorySlug: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20modern%20drama%20scene%20with%20two%20actors%20in%20elegant%20urban%20setting%2C%20warm%20city%20night%20lights%2C%20romantic%20atmosphere%2C%20soft%20cinematic%20lighting%2C%20emotional%20moment%2C%20professional%20TV%20drama%20photography%20style%20with%20shallow%20depth%20of%20field&width=800&height=450&seq=article-cover-2&orientation=landscape',
    publishDate: '2026-08-06',
    views: 98400,
    likes: 38700,
    duration: '45:00',
    tags: ['都市剧', '情感', '国产剧', '收视率'],
    content: '<p>都市情感大剧《繁花似锦》昨夜迎来了万众期待的大结局。这部由实力派演员领衔主演的电视剧，自开播以来热度持续攀升，最终以全国收视率3.8%的惊人成绩完美收官。</p><p>该剧以繁华都市为背景，讲述了几个年轻人在事业和爱情中不断成长的故事。剧情紧凑、情感真挚，加上精良的制作水准，让这部作品成为了今年最受欢迎的电视剧之一。</p><p>大结局播出后，相关话题迅速登上微博热搜榜首，总阅读量突破20亿次。观众纷纷表示"被结局感动到了"，"这是今年看过最好的国产剧"。</p>',
    author: '剧集评论家',
    isHot: true,
    isNew: true,
    isFeatured: true,
  },
  {
    id: 'article-3',
    title: '《欢乐喜剧人》第十二季全新升级，笑点密集全程高能',
    excerpt: '王牌喜剧综艺《欢乐喜剧人》第十二季正式回归，全新赛制和豪华嘉宾阵容让节目看点十足。首期节目笑点不断，观众直呼过瘾。',
    category: '综艺',
    categorySlug: 'zongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20vibrant%20Chinese%20variety%20show%20stage%20with%20comedians%20performing%2C%20colorful%20stage%20lighting%2C%20energetic%20atmosphere%2C%20studio%20audience%20laughing%2C%20professional%20TV%20production%20setup%2C%20warm%20and%20bright%20stage%20design%20with%20spotlights&width=800&height=450&seq=article-cover-3&orientation=landscape',
    publishDate: '2026-08-05',
    views: 76500,
    likes: 31200,
    duration: '01:28:30',
    tags: ['喜剧', '综艺', '欢乐喜剧人', '搞笑'],
    content: '<p>王牌喜剧综艺《欢乐喜剧人》第十二季正式回归！本季节目在赛制上进行了全面升级，采用了更加激烈的淘汰机制和全新的团队对战模式。</p><p>首期节目中，沈腾、马丽等喜剧大咖悉数回归，同时加入了多位新生代喜剧演员。节目全程笑点密集，从小品到脱口秀，从即兴表演到情景剧，多元化的表演形式让观众应接不暇。</p><p>节目播出后，社交媒体上好评如潮，有观众评论"笑到肚子疼，这才是真正的喜剧综艺"。据悉，本季节目共12期，每周五晚黄金档播出。</p>',
    author: '综艺达人',
    isHot: true,
    isNew: true,
    isFeatured: true,
  },
  {
    id: 'article-4',
    title: '《星辰变》第五季定档！国产3D动漫巅峰之作再续传奇',
    excerpt: '国产3D动漫标杆之作《星辰变》第五季正式定档暑期，制作团队透露本季将解锁更多宏大场景和炫酷战斗场面，画质全面升级至4K。',
    category: '动漫',
    categorySlug: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20stunning%20Chinese%203D%20animation%20scene%20with%20a%20warrior%20in%20fantasy%20world%2C%20magical%20effects%2C%20epic%20landscape%20with%20floating%20mountains%2C%20dynamic%20action%20pose%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20professional%20animation%20style%20rendering&width=800&height=450&seq=article-cover-4&orientation=landscape',
    publishDate: '2026-08-04',
    views: 89200,
    likes: 35800,
    duration: '22:00',
    tags: ['国产动漫', '3D动画', '星辰变', '玄幻'],
    content: '<p>国产3D动漫的标杆之作《星辰变》第五季正式定档暑期！这部由国内顶尖动画团队打造的玄幻巨制，自从第一季播出以来就以其精良的制作水准赢得了无数观众的喜爱。</p><p>制作团队透露，第五季将解锁更多的宏大场景，包括神秘的星辰海和传说中的天界。战斗场面全面升级，特效团队投入了比上一季多一倍的时间和精力来打造堪比电影级别的视觉效果。</p><p>值得一提的是，本季动画画质将全面升级至4K分辨率，帧率也提升至60帧，为观众带来更加流畅和细腻的视觉体验。粉丝们纷纷表示"已经等不及了"。</p>',
    author: '动漫情报局',
    isHot: false,
    isNew: true,
    isFeatured: true,
  },
  {
    id: 'article-5',
    title: '《地球脉动III》中国篇震撼上线，记录华夏大地壮美生态',
    excerpt: 'BBC经典纪录片系列《地球脉动》第三季中国篇正式上线，用4K超高清镜头记录了中国从青藏高原到南海珊瑚礁的壮美生态画卷。',
    category: '纪录片',
    categorySlug: 'jilupian',
    coverImage: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20of%20Chinese%20landscape%20with%20snow%20mountains%20and%20wildlife%2C%20crystal%20clear%20aerial%20view%2C%20dramatic%20natural%20lighting%2C%20professional%20wildlife%20photography%2C%20warm%20earth%20tones%20with%20vibrant%20greenery&width=800&height=450&seq=article-cover-5&orientation=landscape',
    publishDate: '2026-08-03',
    views: 56700,
    likes: 23400,
    duration: '58:00',
    tags: ['纪录片', '自然', 'BBC', '中国生态'],
    content: '<p>BBC经典纪录片系列《地球脉动》第三季中国篇正式上线！这次，摄制组深入中国各地，从青藏高原的雪豹到云南的热带雨林，从东北的虎豹到南海的珊瑚礁，用4K超高清镜头记录下了华夏大地的壮美生态。</p><p>中国篇历时三年拍摄，足迹遍布中国20多个省份。片中首次记录到了多种珍稀动物的罕见行为，包括大熊猫在野外的求偶仪式和藏羚羊的大规模迁徙。</p><p>本片特邀著名配音演员进行中文旁白配音，让中国观众能够更加投入地感受这部自然史诗的魅力。上线后，该片在豆瓣获得了9.7分的高分评价。</p>',
    author: '自然探索者',
    isHot: false,
    isNew: true,
    isFeatured: false,
  },
  {
    id: 'article-6',
    title: '创意美食短视频《舌尖上的小城》系列爆红网络',
    excerpt: '短视频系列《舌尖上的小城》凭借独特的拍摄手法和烟火气十足的内容迅速走红，展现了各地小城隐藏的美食宝藏。',
    category: '短视频',
    categorySlug: 'duanshipin',
    coverImage: 'https://readdy.ai/api/search-image?query=Delicious%20Chinese%20street%20food%20being%20prepared%20in%20a%20cozy%20small%20town%20setting%2C%20steaming%20hot%20dishes%2C%20warm%20ambient%20lighting%2C%20authentic%20local%20atmosphere%2C%20food%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20rich%20warm%20tones&width=800&height=450&seq=article-cover-6&orientation=landscape',
    publishDate: '2026-08-02',
    views: 156300,
    likes: 67800,
    duration: '03:20',
    tags: ['美食', '短视频', '探店', '文化'],
    content: '<p>短视频系列《舌尖上的小城》近日在各大平台迅速走红。这个由独立创作者打造的系列视频，以独特的拍摄视角和充满烟火气的内容，展现了散落在全国各地小城中的美食宝藏。</p><p>从湘西的烟熏腊肉到潮汕的牛肉丸，从新疆的烤包子到云南的过桥米线，每一集都深入一座小城，探访一家传承数代的老店。视频采用了电影级别的运镜和调色，让每一道美食都散发着诱人的魅力。</p><p>截至目前，该系列已更新至第36集，全网累计播放量突破5亿次。创作者表示，希望通过镜头让更多人了解和珍惜中国各地的传统美食文化。</p>',
    author: '美食猎人',
    isHot: true,
    isNew: false,
    isFeatured: false,
  },
  {
    id: 'article-7',
    title: '《暗夜追踪》口碑爆棚，悬疑犯罪片新标杆',
    excerpt: '国产悬疑犯罪片《暗夜追踪》上映首周末票房突破5亿，豆瓣评分8.6分。影片以其精巧的剧情设计和演员的精湛演技赢得了观众和影评人的一致好评。',
    category: '电影',
    categorySlug: 'dianying',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20dark%20and%20moody%20crime%20thriller%20scene%20with%20a%20detective%20in%20rainy%20city%20street%20at%20night%2C%20neon%20lights%20reflecting%20on%20wet%20pavement%2C%20noir%20atmosphere%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20professional%20film%20photography&width=800&height=450&seq=article-cover-7&orientation=landscape',
    publishDate: '2026-08-01',
    views: 89300,
    likes: 36500,
    duration: '02:12',
    tags: ['悬疑', '犯罪', '国产电影', '口碑'],
    content: '<p>国产悬疑犯罪片《暗夜追踪》上映首周末即斩获5亿票房，成为今年暑期档最大的黑马。影片以一起离奇的连环案件为主线，讲述了刑警队长在追查真相过程中经历的种种波折。</p><p>影片的叙事结构精巧，多条时间线交错推进，每一个细节都经过精心设计。主演的表演被影评人称赞为"近年来最出色的犯罪片表演之一"，将角色的内心挣扎和坚韧展现得淋漓尽致。</p><p>豆瓣评分稳定在8.6分，超越了同期上映的多部好莱坞大片。有影评人评价："《暗夜追踪》不仅是一部优秀的悬疑片，更是一部有深度的社会题材作品。"</p>',
    author: '影评人老张',
    isHot: true,
    isNew: true,
    isFeatured: false,
  },
  {
    id: 'article-8',
    title: '《山河令》续集《江湖再会》正式开机，原班人马回归',
    excerpt: '武侠剧经典《山河令》续集《江湖再会》昨日在横店正式开机，导演携原班主演阵容亮相开机仪式，引发粉丝热烈期待。',
    category: '电视剧',
    categorySlug: 'dianshiju',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Chinese%20martial%20arts%20drama%20scene%20with%20actors%20in%20traditional%20costumes%20in%20ancient%20Chinese%20setting%2C%20bamboo%20forest%20background%2C%20soft%20golden%20sunlight%2C%20elegant%20composition%2C%20cinematic%20wuxia%20aesthetic&width=800&height=450&seq=article-cover-8&orientation=landscape',
    publishDate: '2026-07-30',
    views: 67100,
    likes: 28900,
    duration: '03:05',
    tags: ['武侠', '国产剧', '山河令', '续集'],
    content: '<p>备受武侠迷期待的《山河令》续集《江湖再会》昨日在横店影视城正式开机。导演携原班主演阵容出席了开机仪式，现场气氛热烈。</p><p>据悉，《江湖再会》的故事将发生在第一部结局的五年之后，主角们将面临全新的江湖危机和更深刻的人性考验。编剧团队花费了两年时间打磨剧本，力求在延续前作风格的基础上带来新的突破。</p><p>制作方表示，续集的制作预算比前作增加了60%，将采用更先进的特效技术和更宏大的场景搭建，为观众呈现一个更加真实和震撼的武侠世界。预计2027年暑期档播出。</p>',
    author: '影视圈内人',
    isHot: false,
    isNew: true,
    isFeatured: false,
  },
  {
    id: 'article-9',
    title: '《声入人心》第五季海选启动，寻找下一个音乐天才',
    excerpt: '大型音乐竞技综艺《声入人心》第五季全国海选正式启动，节目组将走遍全国30座城市，寻找最具潜力的音乐新星。',
    category: '综艺',
    categorySlug: 'zongyi',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20grand%20music%20competition%20stage%20with%20a%20singer%20performing%20under%20dramatic%20spotlights%2C%20elegant%20stage%20design%2C%20captivated%20audience%2C%20warm%20golden%20and%20amber%20lighting%2C%20professional%20concert%20photography&width=800&height=450&seq=article-cover-9&orientation=landscape',
    publishDate: '2026-07-29',
    views: 54200,
    likes: 21300,
    duration: '01:15:40',
    tags: ['音乐', '综艺', '选秀', '声入人心'],
    content: '<p>大型音乐竞技综艺《声入人心》第五季全国海选正式启动！节目组宣布将走遍全国30座城市，通过线上线下相结合的方式，寻找最具潜力的音乐新星。</p><p>本季节目在赛制上进行了创新调整，增加了原创音乐环节和跨界合作挑战，让选手们不仅要比拼唱功，还要展现创作能力和舞台想象力。</p><p>导师阵容方面，节目组透露将邀请多位华语乐坛重量级人物加盟，其中不乏首次担任综艺导师的天王天后级别歌手。海选报名通道已全面开放。</p>',
    author: '音乐爱好者',
    isHot: false,
    isNew: false,
    isFeatured: false,
  },
  {
    id: 'article-10',
    title: '《深海迷城》预告公开，国产动画电影再攀高峰',
    excerpt: '国产动画电影《深海迷城》发布首支预告片，惊艳的画面效果和独特的艺术风格引发业内广泛关注，被视为国产动画的又一里程碑。',
    category: '动漫',
    categorySlug: 'dongman',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20visually%20stunning%20animated%20underwater%20fantasy%20city%20scene%2C%20bioluminescent%20creatures%2C%20mysterious%20deep%20ocean%20atmosphere%2C%20vibrant%20coral%20reefs%2C%20artistic%20animation%20style%2C%20warm%20and%20cool%20color%20contrast%2C%20dreamy%20underwater%20lighting&width=800&height=450&seq=article-cover-10&orientation=landscape',
    publishDate: '2026-07-28',
    views: 72100,
    likes: 30200,
    duration: '01:45',
    tags: ['动画电影', '国产动漫', '深海', '原创'],
    content: '<p>国产动画电影《深海迷城》发布了首支预告片，短短一分多钟的画面惊艳了无数观众。影片以深海世界为舞台，讲述了一个关于勇气、探索和友情的奇幻冒险故事。</p><p>从预告片来看，影片在视觉呈现上达到了新的高度。制作团队采用了全新的渲染技术，将深海世界的瑰丽与神秘展现得震撼而迷人。独特的艺术风格融合了中国传统水墨元素和现代CG技术，创造出令人过目不忘的视觉语言。</p><p>该片由曾参与多部迪士尼动画制作的中国动画师执导，耗时五年打造。业内人士评价其为"国产动画电影的新里程碑"。影片计划于2027年春节档上映。</p>',
    author: '动画观察室',
    isHot: false,
    isNew: false,
    isFeatured: false,
  },
  {
    id: 'article-11',
    title: '《科技简史》纪录片系列热度不减，科普类内容成新趋势',
    excerpt: '科普纪录片系列《科技简史》自上线以来热度持续走高，以生动有趣的方式讲述科技发展历程，吸引了大量年轻观众的关注。',
    category: '纪录片',
    categorySlug: 'jilupian',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20futuristic%20technology%20museum%20interior%20with%20holographic%20displays%20showing%20scientific%20history%2C%20warm%20ambient%20lighting%2C%20clean%20modern%20design%2C%20interactive%20exhibits%2C%20professional%20documentary%20photography%20style&width=800&height=450&seq=article-cover-11&orientation=landscape',
    publishDate: '2026-07-27',
    views: 48700,
    likes: 19600,
    duration: '42:00',
    tags: ['科普', '纪录片', '科技', '教育'],
    content: '<p>科普纪录片系列《科技简史》自上线以来热度持续走高，成为今年最受欢迎的纪录片之一。该系列以生动有趣的叙事方式和精美的视觉呈现，将人类科技发展的宏大历程娓娓道来。</p><p>从火的发现到人工智能的崛起，每一集围绕一个核心主题展开，通过专家访谈、历史重现和CG动画相结合的方式，让深奥的科技知识变得通俗易懂。特别是年轻观众群体，对该系列反响热烈。</p><p>截至目前，该系列已更新至第18集，全网累计播放量突破8亿次。平台方表示，科普类内容正在成为视频平台的新增长点，未来将加大对优质科普内容的扶持力度。</p>',
    author: '科技观察者',
    isHot: false,
    isNew: false,
    isFeatured: false,
  },
  {
    id: 'article-12',
    title: '旅行博主"行走的相机"短视频合集播放量突破10亿',
    excerpt: '知名旅行博主"行走的相机"的短视频合集全网播放量正式突破10亿大关，其独特的拍摄风格和真诚的旅行故事感染了无数观众。',
    category: '短视频',
    categorySlug: 'duanshipin',
    coverImage: 'https://readdy.ai/api/search-image?query=A%20travel%20photographer%20standing%20on%20a%20mountain%20peak%20at%20sunset%20with%20camera%2C%20breathtaking%20landscape%20view%2C%20warm%20golden%20hour%20lighting%2C%20adventure%20lifestyle%20photography%2C%20epic%20scale%20with%20dramatic%20clouds&width=800&height=450&seq=article-cover-12&orientation=landscape',
    publishDate: '2026-07-26',
    views: 189200,
    likes: 82300,
    duration: '05:40',
    tags: ['旅行', '短视频', '摄影', '户外'],
    content: '<p>知名旅行博主"行走的相机"的短视频合集全网累计播放量正式突破10亿大关，成为旅行类短视频领域的标杆创作者。</p><p>"行走的相机"以其独特的镜头语言和真诚的叙事风格著称。他的视频不仅仅是风景的堆砌，而是通过一个个小而美的旅行故事，传递着对生活的热爱和对世界的好奇心。从西藏的无人区到海南的渔村，从大兴安岭的秋天到云南的茶山，他的足迹遍布中国大江南北。</p><p>在接受采访时，他分享道："每一段视频背后都是一个真实的故事。我希望通过我的镜头，让更多人看到这个世界的美丽，也唤起大家对旅行的向往。"</p>',
    author: '短视频观察',
    isHot: true,
    isNew: false,
    isFeatured: false,
  },
];

export function getArticlesByCategory(categorySlug: string): Article[] {
  return articles.filter((a) => a.categorySlug === categorySlug);
}

export function getArticleById(id: string): Article | undefined {
  return articles.find((a) => a.id === id);
}

export function getFeaturedArticles(): Article[] {
  return articles.filter((a) => a.isFeatured);
}

export function getHotArticles(): Article[] {
  return articles.filter((a) => a.isHot);
}

export function getNewArticles(): Article[] {
  return articles.filter((a) => a.isNew);
}

export function getRelatedArticles(article: Article, limit: number = 4): Article[] {
  return articles
    .filter((a) => a.categorySlug === article.categorySlug && a.id !== article.id)
    .slice(0, limit);
}